<template>
    <div class="element-button--icon element-button" 
        @click.prevent="toggle()">
        <svg :class="['element-icon--' + fillClass, 'element-icon']" width="1em" height="1em"><use :href="'/img/icons.svg#icon-' + fillClass"></use></svg>
    </div>
</template>

<script>
import _ from 'lodash'
import store from '../store'

export default {
    store,
    props: {
        projectId: {
            type: Number
        }
    },
    computed: {
        fillClass () {
            return this.value ? 'favorite-filled' : 'favorite-empty'
        },
        value () {
            return this.$store.state.favorites.indexOf(this.projectId) >= 0
        }
    },
    methods: {
        toggle () {
            this.$store.dispatch('toggleFavorite', this.projectId)
        }
    }
}
</script>
